const invertedMessages = {
  Remove: 'external.rules.tabs.remove',
  Cancel: 'external.rules.tabs.cancel',
  'Review Rule and Make Changes if necessary': 'external.rules.tabs.reviewtext',
  'Show User Samples': 'external.rules.tabs.showUserSamples',
  'Hide User Samples': 'external.rules.tabs.hideUserSamples',
  'Loading sample users': 'external.rules.tabs.loadingUserSamples',
  'Based on the rule, here are some user data sample:':
    'external.rules.tabContent.title',
  'Applies to': 'external.rules.tabContent.appliesTo',
  'External Users': 'external.rules.tabContent.externalUsers',
  'No matching users.': 'external.rules.tabContent.noMatchingUsers',
  Confirmed: 'external.rules.confirmed',
  Confirm: 'external.rules.confirm',
  'Create New Rule': 'external.rules.create',
  testlabel: 'Users.owner.label',
  Active: 'external.search.identities.active',
  Inactive: 'external.search.identities.inactive',
  'Suspended From Import Service': 'external.search.identities.status7',
  'Confirm to remove rule?': 'external.rules.remove.confirmTitle',
  'This action cannot be undone. The selected rule will be removed from the list.':
    'external.rules.remove.confirmSubTitle',
};

export default invertedMessages;
